import { createLogger } from '@owl-lib/logger';
import type { UserForm } from '../../components/AdminPanelContainer/UsersContainer/NewUserModal';
import { deserialize, fetchWrapper } from '../fetch';
import type { User, UserAdmin } from '../interface';
const logger = createLogger(__filename);

const usersApiClient = {
  users: async (): Promise<User[]> => {
    const url = new URL('/app/v1/users', API_BASE_URL);
    logger.trace('usersApiClient.users()');
    return deserialize(
      await fetchWrapper(url.href, { method: 'GET', credentials: 'include' })
    );
  },
  usersAdmin: async (): Promise<UserAdmin[]> => {
    const url = new URL('/app/v1/users', API_BASE_URL);
    url.searchParams.set('incl_cognito_data', 'true');
    logger.trace('usersApiClient.usersAdmin()');
    return deserialize(
      await fetchWrapper(url.href, { method: 'GET', credentials: 'include' })
    );
  },
  create: async (
    userData: UserForm & Pick<User, 'full_name'>
  ): Promise<number> => {
    const url = new URL('/app/v1/users', API_BASE_URL);
    logger.trace('usersApiClient.create()');

    return deserialize(
      await fetchWrapper(url.href, {
        method: 'POST',
        credentials: 'include',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(userData),
      })
    );
  },
  delete: async (email: string): Promise<number> => {
    const url = new URL('/app/v1/users', API_BASE_URL);
    url.searchParams.set('user_email_to_delete', email);
    logger.trace('usersApiClient.delete()');

    return deserialize(
      await fetchWrapper(url.href, { method: 'DELETE', credentials: 'include' })
    );
  },
  resendSignInEmail: async (email: string): Promise<void> => {
    const url = new URL(
      `/app/v1/users/${encodeURIComponent(email)}/signin-email`,
      API_BASE_URL
    );
    logger.trace('usersApiClient.resendSignInEmail()');

    return deserialize(
      await fetchWrapper(url.href, {
        method: 'POST',
        credentials: 'include',
        headers: {
          'Content-Type': 'application/json',
        },
      })
    );
  },
};

export default usersApiClient;
